import React from 'react'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faXTwitter, faTiktok, faYoutube} from '@fortawesome/free-brands-svg-icons';

const x_link = "https://x.com/HWFW_"; 
const facebook_link = "https://www.facebook.com/profile.php?id=61574605786271";
const instagram_link = "https://www.instagram.com/healingwatersforwarriors"; 
const tiktok_link = "https://www.tiktok.com/@watersforwarriors";
const youtube_link = "https://www.youtube.com/@healingwatersforwarriors"; 


const SocialMediaLinks = () => {

    return(
        <div className="header-social-media-links"
            style={{
                display: 'flex', 
                justifyContent: 'center', 
                gap: '15px',
                marginTop: '0.5em'
            }}
        >
            <a href={facebook_link} target="_blank" rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
            >
                <FontAwesomeIcon icon={faFacebook} size="2x" />
            </a>
            <a href={instagram_link} target="_blank" rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
            >
                <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a href={tiktok_link} target="_blank" rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
            >
                <FontAwesomeIcon icon={faTiktok} size="2x" />
            </a>
            <a href={youtube_link} target="_blank" rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
            >
                <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
            <a href={x_link} target="_blank" rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
            >
                <FontAwesomeIcon icon={faXTwitter} size="2x" />
            </a>
        </div>
    )
};

export default SocialMediaLinks; 